import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthStore } from '../../stores/auth.store';
import { AuthManagerService } from '../../managers/auth-manager.service';
import { JwtHelperService } from '@auth0/angular-jwt';

export const authGuard: CanActivateFn = async (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authStore = inject(AuthStore);
  const authManager = inject(AuthManagerService);
  const router = inject(Router);
  const jwtHelper = new JwtHelperService();

  // Ensure token is loaded from storage on refresh
  let token = authStore.token();
  if (!token) {
    token = authStore.loadTokenFromStorage();
  }

  if (token && !jwtHelper.isTokenExpired(token)) {
    // Token is valid — check for admin role
    if (!authStore.isAdmin()) {
      return router.createUrlTree(['/not-authorized']);
    }
    return true;
  }

  // Token expired — attempt refresh before redirecting to login
  if (token) {
    const refreshed = await authManager.refreshAuth();
    if (refreshed) {
      if (!authStore.isAdmin()) {
        return router.createUrlTree(['/not-authorized']);
      }
      return true;
    }
  }

  authStore.clearAuth();

  const attemptedUrl = state.url;
  const isSafeReturnUrl = attemptedUrl.startsWith('/') && !attemptedUrl.startsWith('//');
  const queryParams = isSafeReturnUrl && attemptedUrl !== '/' && attemptedUrl !== '/home'
    ? { returnUrl: attemptedUrl }
    : undefined;

  return router.createUrlTree(['/login'], queryParams ? { queryParams } : {});
};
